import { Button as MaterialButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Role } from '../api/user/Role';
import { Listing } from '../components/Pages/Listing';
import { ExportButton, MentorInviteModal } from '../components/common';
import BaseLayout from '../components/layout/base-layout';
import MentorsList from '../components/lists/mentors-list';
import MentorAssignModal from '../components/mentors/mentor-assign-modal';
import MentorProfileUpdateModal from '../components/mentors/mentor-profile-update-modal';
import MentorArchiveModal from '../components/mentors/mentors-archive-modal';
import MentorsTable from '../components/tables/mentors-table';
import {
  MentorsProvider,
  useMentorsContext,
} from '../contexts/mentors-context';
import { useResourceBundles } from '../contexts/resource-bundles-context';
import { UserContext } from '../contexts/user-context';
import { Pages } from '../router/constants';
import { ProtectedRouteProps } from '../router/type';
import { isMobile } from '../utils/functions';
import { CLASS_TRACKING } from '../utils/tracking_class';
import MyMentorsPage from './my-mentors';

function Mentors({ user }: ProtectedRouteProps) {
  const { hasAccessToAction, hasRole } = useContext(UserContext);
  const { rb } = useResourceBundles();
  const { inviteTargetMentorId, setInviteTargetMentorId } = useMentorsContext();

  return hasRole(Role.Founder) ? (
    <MyMentorsPage user={user} />
  ) : (
    <BaseLayout user={user} fullWidth hiddenFooter={isMobile()}>
      <Listing
        title={rb('mentors-u')}
        actions={[
          {
            key: 'new-mentor',
            label: `New ${rb('mentor-u')}`,
            hidden: !hasAccessToAction('mentor.create'),
            component: (
              <MaterialButton
                className={CLASS_TRACKING.ENTITY_ACTION}
                data-testid='button-new-mentor'
                component={Link}
                to={Pages.NEW_MENTOR}
                startIcon={<AddIcon />}
                variant='contained'
                color='primary'>
                {rb('mentor-u')}
              </MaterialButton>
            ),
          },
          {
            key: 'export',
            label: 'Export',
            hidden: !hasAccessToAction('mentor.export') || isMobile(),
            component: <ExportButton alias='mentor' />,
          },
        ]}>
        {isMobile() ? <MentorsList /> : <MentorsTable />}
      </Listing>
      <MentorArchiveModal />
      <MentorProfileUpdateModal />
      <MentorAssignModal />
      <MentorInviteModal
        open={!!inviteTargetMentorId}
        mentorId={inviteTargetMentorId}
        onClose={() => setInviteTargetMentorId(null)}
      />
    </BaseLayout>
  );
}

function MentorsPage(props: ProtectedRouteProps) {
  return (
    <MentorsProvider>
      <Mentors {...props} />
    </MentorsProvider>
  );
}

export default MentorsPage;
